'use client';
import { CatTextLink } from '@blocks-react/components/TextLink';
import { Conditional } from 'components/pcc-components';
import cx from 'classnames';
import styles from './style.module.scss';

export const NestedSubCategory = ({
  children,
  name,
  seoURL,
  className = '',
  subCategories = [],
  ...rest
}) => {
  return (
    <li>
      <CatTextLink
        href={seoURL}
        size={'sm'}
        className={cx(styles['subCategory__link'], className)}
        {...rest}
      >
        {name}
      </CatTextLink>
      <Conditional test={subCategories.length > 0}>
        <ul className={cx('list-unstyled')} data-testid="subCategory-tier">
          {subCategories.map((ele) => children(ele))}
        </ul>
      </Conditional>
    </li>
  );
};
